module.exports = __webpack_public_path__ + "img/link.5121a51a.svg";